import { ContactEmail } from "./ContactEmail";

/** Who the notice is for and who is responsible for the data. */
export function PrivacyIntro({ contact }: { contact: string }): React.JSX.Element {
  const mail = <ContactEmail contact={contact} />;
  return (
    <>
      <p>
        This notice explains how your personal data is handled when you use Nabble Suite, the workspace your organization gives you
        for your work. It is written for the employees and collaborators of the organizations that use it.
      </p>

      <h3>Who is responsible for your data</h3>
      <p>
        Each organization that uses Nabble Suite is responsible for the personal data of its own people: it decides who gets an
        account and what the suite is used for. Nabble SpA, based in Santiago, Chile, operates the platform on their behalf. For any
        question about your personal data, write to {mail}.
      </p>
    </>
  );
}
